import { Fragment, ReactElement } from 'react';
import EditNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/edit';
import { IdAmbito } from 'shell/constants/id-ambito';

const EditNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <EditNotificationsCivilStatusShared scope={IdAmbito.Cancellazioni} />
    </Fragment>
  );
};

EditNotificationsCivilStatusPage.displayName = 'Edit Notifications Civil Status component';

export default EditNotificationsCivilStatusPage;
